module.exports = __webpack_public_path__ + "static/img/banner1.3508a58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clinic/banner1.png
// module id = A6d7
// module chunks = 1